
import {
  assoc, identity, ifElse, is, mergeDeepLeft, nth, pipe, replace, toUpper, trim,
} from 'ramda';

export const stylize = pipe(
  trim,
  replace(/\s/g, '_'),
  toUpper,
);
export const camelCase = pipe(
  trim,
  replace(/\s(\w)/g, toUpper),
  replace(/\s/g, ''),
);

export const makeActions = ({ prefix, types }) => types.reduce((acc, type) => {
  const stylizedType = stylize(type);
  const properType = prefix ? `${stylize(prefix)}/${stylizedType}` : stylizedType;
  return {
    ...acc,
    [camelCase(type)]: {
      type   : properType,
      creator: (props = {}) => (
        { type: properType, ...props }
      ),
    },
  };
}, {});

export const makeReducer = ({
  initialState,
  reducers,
}) => (state = initialState, { type, ...props }) => {
  const reducer = reducers[type];
  return reducer ? reducer(state, props) : state;
};


export const ASYNC_FETCH_INITIAL_STATE = {
  data   : null,
  error  : null,
  loading: false,
};

export const makeAsyncFetchActions = type => ['', 'success', 'error'].map(stateType => `${type} ${stateType}`);

const getKey = ifElse(
  is(Array),
  nth(0),
  identity
);

export const makeAsyncFetchReducer = (props) => {
  const keys = {
    success: getKey(props.success),
    error  : getKey(props.error),
    init   : getKey(props.init),
  };
  return {
    [keys.init]: Array.isArray(props.init)
      ? props.init[1]
      : assoc(props.key, {
        ...props.initialState || ASYNC_FETCH_INITIAL_STATE,
        loading: true,
      }),
    [keys.success]: Array.isArray(props.success)
      ? props.success[1]
      : (state, { payload }) => mergeDeepLeft({
        [props.key]: {
          loading: false,
          data   : payload,
        },
      }, state),
    [keys.error]: Array.isArray(props.error)
      ? props.error[1]
      : (state, { error }) => mergeDeepLeft({
        [props.key]: {
          loading: false,
          error,
        },
      }, state),
  };
};
